class Transform {
  constructor({ response, data }) {
    this.response = response;
    this.data = data;
  }

  get productList() {
    const array = [];
    this.response.map(item => {
      const data = {
        admin_fee: item.admin_fee,
        category: item.category,
        currency_code: item.currency_code,
        detail: item.detail,
        hardcopy_admin_fee: item.hardcopy_admin_fee,
        insurance: item.insurance,
        insurance_code: item.insurance_code,
        insurer_name: item.insurer_name,
        logo: item.logo,
        name: item.name,
        premium: item.premium,
        premium_period: item.premium_period,
        premium_type: item.premium_type,
        product_category: item.product_category,
        product_code: item.product_code,
        type: 'smartphone'
      };
      array.push(data);
    });
    return array;
  }

  get prequoteData() {
    const item = this.data;
    let Obj = {
      model: '',
      type: '',
      period: ''
    };
    if (item) {
      Obj = {
        model: item.model.id,
        type: item.type.value,
        period: item.period
      };
      return Obj;
    }
    return Obj;
  }

  get productDetail() {
    const item = this.response;
    let Obj = {
      admin_fee: '',
      category: {
        code: '',
        description: '',
        name: ''
      },
      currency_code: '',
      detail: {
        claim: {
          flow: [],
          support: {
            available: '',
            call: '',
            email: '',
            whatsapp: ''
          }
        },
        excerpt: [],
        label: [],
        position: '',
        product: {
          coverages: [],
          description: '',
          generalInsuranceName: '',
          name: '',
          planCode: '',
          spesific: [],
          url: {
            brochure: '',
            tnc: ''
          }
        },
        terms: []
      },
      hardcopy_admin_fee: '',
      insurance: {
        code: '',
        logo: '',
        name: ''
      },
      insurance_code: '',
      insurer_name: '',
      logo: '',
      name: '',
      premium: 0,
      premium_period: '',
      premium_type: '',
      product_category: '',
      product_code: '',
      terms: ''
    };
    if (item) {
      Obj = {
        admin_fee: item.admin_fee,
        category: {
          code: item.category.code,
          description: item.category.description,
          name: item.category.name
        },
        currency_code: item.currency_code,
        detail: {
          claim: {
            flow: item.detail.claim.flow,
            support: {
              available: item.detail.claim.support.available,
              call: item.detail.claim.support.call,
              email: item.detail.claim.support.email
            }
          },
          excerpt: item.detail.excerpt,
          label: item.detail.label,
          position: item.detail.position,
          product: {
            coverages: item.detail.product.coverages,
            description: item.detail.product.description,
            generalInsuranceName: item.detail.product.generalInsuranceName,
            name: item.detail.product.name,
            planCode: item.detail.product.planCode,
            spesific: item.detail.product.spesific,
            url: {
              brochure: item.detail.product.url.brochure,
              tnc: item.detail.product.url.tnc
            }
          },
          terms: item.detail.terms
        },
        hardcopy_admin_fee: item.hardcopy_admin_fee,
        insurance: {
          code: item.insurance.code,
          logo: item.insurance.logo,
          name: item.insurance.name
        },
        insurance_code: item.insurance_code,
        insurer_name: item.insurer_name,
        logo: item.logo,
        name: item.name,
        premium: item.premium,
        premium_period: item.premium_period,
        premium_type: item.premium_type,
        product_category: item.product_category,
        product_code: item.product_code,
        terms: item.terms
      };
      return Obj;
    }
    return Obj;
  }
}

export const mapResponse = ({ type, response }) => {
  const transformResponse = new Transform({ response });
  return transformResponse[type];
};

export const mapPayload = ({ type, data }) => {
  const transformPayload = new Transform({ data });
  return transformPayload[type];
};
